module.exports = __webpack_public_path__ + "static/media/modal-close-small-dark.7a872ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/modal-close-small-dark.svg
// module id = 817
// module chunks = 0